import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { md3 } from 'vuetify/blueprints';
import { aliases, md } from 'vuetify/iconsets/md';
import { sl } from 'vuetify/locale';

export default createVuetify({
  blueprint: md3,
  icons: {
    defaultSet: 'md',
    aliases,
    sets: { md },
  },
  theme: {
    defaultTheme: 'sitelogLight',
    themes: {
      sitelogLight: {
        dark: false,
        colors: {
          primary: '#4b9ed6',
          'on-primary': '#202020',
          secondary: '#6bc5ef',
          'on-secondary': '#202020',
          tertiary: '#202020',
          'on-tertiary': '#ffffff',
          error: '#b71c1c',
          'on-error': '#ffffff',
          surface: '#fffbfe',
          'on-surface': '#1d1b20',
          background: '#fffbfe',
          'on-background': '#1d1b20',
        },
      },
    },
  },
  locale: {
    locale: 'sl',
    fallback: 'sl',
    messages: { sl },
  },
});
